export default __webpack_public_path__ + "static/media/thumbnail3.de8947af.jpg";